import { RootState } from "../store";

export const selectPoolConfig = (state: RootState) => state.poolConfigState;
